import Toolbar from '@material-ui/core/Toolbar';
import { Badge as BadgeCore } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors, fonts } from '~/layout';

export const AppBarDiv = lib.styled.div`
  margin-bottom: 2px;
  background-color: ${colors.white02}!important;
  display: flex;
  flex-direction: row!important;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding-right: 0px;
  z-index: 9!important;
  box-shadow: 0 0px 4px 0 rgba(32,33,36,0.18)!important;

  .statusDuringCall {
    color: ${colors.white}!important;
  }
`;

export const ToolbarDiv = lib.styled(Toolbar)``;

export const Settings = lib.styled(BadgeCore)`
  .MuiBadge-badge {
    height: 12px;
    width: 12px;
    min-width: 10px;
    padding: 0px;
    background-color: ${props => props.bgcolor};
    border: 1px solid ${colors.white};
  }
  
  span {
    margin-top: 2px;
  }
`;

export const LeftSide = lib.styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 59px;
  height: 50px;
  cursor: pointer;

  .MuiAvatar-colorDefault {
    background-color: ${colors.lightGray08};
    color: ${colors.white};
    border: 1px solid  ${colors.white};
  }

  .MuiAvatar-root {
    font-size: ${fonts.default}px;
  }
`;

export const RightSide = lib.styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: ${props => (props.center ? 'center' : 'flex-end')};
`;
